import { Styles } from 'shared/types';
import { colors } from 'shared/utils';

export const PageTitle: Styles = {
  px: 1,
  py: 2,
  fontSize: '20px',
  fontWeight: 500,
  lineHeight: '160%',
};

export const Form: Styles = {
  display: 'flex',
  flexDirection: 'column',
  gap: 3,
  mb: 3,
};

export const DatePickerWrapper = (isError: boolean): Styles => ({
  width: 220,
  borderRadius: 2,
  border: '1px solid',
  borderColor: isError ? colors.tomato : 'transparent',

  '&:hover': {
    backgroundColor: colors.brightGray,
  },

  '&:has(.Mui-focused)': {
    backgroundColor: 'transparent',
    borderColor: colors.blueberry,
  },
});

export const DatePickerMessage: Styles = {
  color: colors.tomato,
  pl: 1,
};

export const FeedbackForm: Styles = {
  p: ({ spacing }) => spacing(1),
  backgroundColor: 'ghostWhite',
};

export const SubmitWrapper: Styles = {
  p: ({ spacing }) => spacing(0.25, 3, 1.25),
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
};

export const ContentWrapper: Styles = {
  p: ({ spacing }) => spacing(2, 3),
};

export const ReturnTitle: Styles = {
  mb: 2,
};

export const ReturnDescription: Styles = {
  mb: 3,
};

export const ReturnButtonWrapper: Styles = {
  width: '100%',
  display: 'flex',
  gap: 3,
};

export const FormActionsWrapper: Styles = {
  width: '100%',
  display: 'flex',
  justifyContent: 'flex-end',
  gap: 2,
};
